import { CircularProgress, styled } from "@mui/material";

const Container = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  height: "100vh",
  justifyContent: "center",
}));

export default function Loading() {
  return (
    <Container>
      <CircularProgress />
    </Container>
  );
}
